import { Range } from "react-range";
import React, { useEffect, useState } from "react";

function Slider({ setSmoothDistance }) {
  const [value, setValue] = useState([5]);
  useEffect(() => {
    setSmoothDistance(value[0]);
  }, [value]);

  return (
    <Range
      step={0.1}
      min={0}
      max={10}
      values={value}
      onChange={(value) => setValue(value)}
      renderTrack={({ props, children }) => (
        <div
          {...props}
          style={{
            ...props.style,
            height: "0.5em",
            width: "10em",
            backgroundColor: "#555555",
            borderRadius: "5px",
          }}
        >
          <div
            style={{
              position: "absolute",
              height: "100%",
              width: `${value[0] * 10}%`, // Set the width based on the value of the slider
              backgroundColor: "lightgrey", // Set the color for the input side
              borderRadius: "5px",
            }}
          />
          {children}
        </div>
      )}
      renderThumb={({ props }) => (
        <div
          {...props}
          style={{
            ...props.style,
            height: "0.8em",
            width: "0.8em",
            backgroundColor: "lightgrey",
            borderRadius: "50%",
          }}
        />
      )}
    />
  );
}
export default Slider;
